<template>
<div class="pa-2">
    <v-text-field v-model="search" ref="searchText" hide-details label="Search" class="ma-2"></v-text-field>

    <div v-for="(category) in menu.categories" :key="category.category.name">
        <div class="heading pa-2">{{category.category.name}}</div>   
        <div class="scroll" style="max-height:200px;border-bottom:dotted 2px #d8d8d8;">
            <template v-for="(policy) in category.policies" >
                <v-tooltip right :key="policy.key">
                    <template v-slot:activator="{ on }">
                    <div @click="$emit('click', policy)" v-on="on" v-if="matchesSearch(policy.name)"  class="list-tile clickable hoverable" :class="{'blue-hilight': isSelected(policy.name)}" :key="policy.name" v-ripple>
                        {{policy.name}} 
                    </div>
                    </template>
                    <span>{{policy.templateName}}</span>
                </v-tooltip>
            </template>
            <div v-if="!search" @click="addDocument(category.category)" class="list-tile clickable hoverable" v-ripple>
                Add {{category.category.name}} Doc
            </div>             
        </div>
        
    </div>
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import NiceData from '../../data/NiceData'
import StringHelpers from '../../helpers/StringHelpers'
import Flag from '../../ui-elements/Flag'

export default {
    data() {
        return {
            search: '',
        }
    },

    components: {
        Flag,
    },
    
    props: {
        // Menu contains: {
        //      checklistKey: XXXX
        //      categories: {policies: {} }
        // }
        menu: Object, 
    },

    computed: {
        selectedPolicies() {
            return this.$store.getters.getSelectedKeys('checklist-policies')
        }
    },

    methods: {

        matchesSearch(policyName) {
            let s = this.search.toLowerCase()
            if(!s)
                return true
            let n = policyName.toLowerCase()
            return (n.indexOf(s) > -1)
        },

        titleClicked(titleObj) {
            this.$emit('click', titleObj)
        },

        isSelected(policyName) {
            return Boolean(this.selectedPolicies.find(p => p == policyName))
        },

        addDocument(category) {
            this.$emit('add', category)
        }

    },

    created() {
 
    }
}
</script>

<style scoped>
.scroll {
    overflow-y:auto;
}
</style>




// WEBPACK FOOTER //
// ChecklistMenu.vue?41b919fc